import * as Twilio from 'twilio-video'
import getScreenStream from '../../lib/getScreenStream'

/** This fetches and publishes a video stream of the user's desktop */
export default async function (localParticipant: Twilio.LocalParticipant, username: string, options = {}): Promise<boolean> {

  let localTrack

  try {

    localTrack = await getScreenStream()

  }
  catch (e) {

    return false

  }

  const publishOptions: Twilio.LocalTrackOptions = {
    logLevel: 'warn',
    name: `${username}-screen-${localTrack.label}`,
    ...options
  }

  try {

    await localParticipant.publishTrack(localTrack, publishOptions)

  }
  catch (e) {

    return false

  }

  return true

}
